module.exports = __webpack_public_path__ + "img/SKMJ_G.b61dcf43.png";